import request from "@/utils/request";

export default function agentSendToAccessControlDevice(data) {
  return request.post(
    `/device/accessControlDirectMsg/agent/sendToAccessControlDevice`,
    data
  );
}
